import { coreApiGatewayKeysUpdateSyncSlice } from '../update';
import { patchApiGatewayKeyById } from '@api/data-security';

import { createPatchAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const patchCoreApiGatewayKeysByIdSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) => coreApiGatewayKeysUpdateSyncSlice.syncActionCreator(request)
		]
	},
	name: 'CoreApiGatewayKeysById',
	receive: true,
	request: true,
	requestHandler: patchApiGatewayKeyById,
	yieldType: SagaYieldType.Latest
});
